import React, { useState } from 'react'
import { FaArrowLeft } from 'react-icons/fa6'
import { Link, useNavigate} from 'react-router-dom'
import Sidebar from './partial/Sidebar'
import Header from './partial/Header'
import toast, { Toaster } from 'react-hot-toast'
import { useAddBannerMutation } from '../../redux/API/BannerApi'
import ChangePassword from './partial/ChangePassword'

const AddBanner = () => {
  const [newClass, setNewClass] = useState("")
  const [newSidebarClass, setNewSidebarClass] = useState("")
  const [showPass, setShowPass] = useState(false)
    const [name, setName] = useState('')
    const [image, setImage] = useState('')
    const [showError, setShowError] = useState({
      name: false,
      image: false
    })
    const handleImageChange = (e) => {
      const fileName = e.target.files[0];
      const sizeLimit = 2 * 1024 * 1024;
      if (fileName && fileName.size <= sizeLimit) {
        const img = new Image();
        img.src = URL.createObjectURL(fileName);
        img.onload = () => {
          if (img.width === 1500 && img.height === 400) {
            setImage(fileName);
          } else {
            toast.error("Image dimensions should be 1500*400");
          }
        };
      } else {
        toast.error("File size should be less than 2MB");
      }
    };
    

    const [postData] = useAddBannerMutation()
    const navigate = useNavigate()
    const handleSubmit = (e) => {
      e.preventDefault()
      const checkFeild = {
        name: name === "",
        image: image === "",
    }
    setShowError(checkFeild);
    const hasError = Object.values(checkFeild).some((error) => error);
    if (hasError) {
    return;
   }
   const formData = new FormData()
   formData.append("title", name)
   formData.append("image", image)
      postData(formData).then((res) => {
        if(res?.data?.success){
          setName('')
          navigate('/admin/banner')
        }
        else{
          toast.error("Something went wrong, Please try later")
        }
      })
      .catch((err) => {
        toast.error(err)
      })
    }

    const handleToggle = () => {
      if (newClass === "") {
        setNewClass("main-active");
        } else {
          setNewClass("");
          }
          if(newSidebarClass === ""){
            setNewSidebarClass("closed");
          }
          else{
            setNewSidebarClass("");
          }
    }
    

  return (
    <>
    <Toaster position='top-right'/>
    <Sidebar
    newSidebarClass={newSidebarClass}
    setShowPass={setShowPass}
    />
    <div className={`main-context ${newClass}`}>
      <Header
      handleToggle={handleToggle}
      />
     <div className="admin-dashboard p-4">
     <div aria-label="breadcrumb">
 <ol className="breadcrumb">
   <li className="breadcrumb-item active" aria-current="page">Add Banner</li>
 </ol>
</div>
<div className="d-flex justify-content-end pe-2 mb-3">
         <Link to="/admin/banner" className="btn btn-primary rounded-2">
         Back <FaArrowLeft/>
         </Link>
         </div>
         <div className="container card p-4">
          <form className='row' onSubmit={handleSubmit}>
             <div className='col-lg-6'>
            <label htmlFor="name">Banner Title</label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                placeholder="Enter Banner Title"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
             {
              showError.name && (
                <p className="text-danger wel mt-1 mb-0">Please Provide Banner Name</p>
              )
             }
             </div>
             <div className='col-lg-6'>
            <label htmlFor="image">Image <sup className='text-danger fs-6'>*</sup></label>
              <input
                type="file"
                multiple
                className="form-control"
                id="iamge"
                name="image"
                onChange={handleImageChange}
              />
             {
              showError.image && (
                <p className="text-danger wel mt-1 mb-0">Please Provide Image</p>
              )
             }
             </div>
              <div className='col-lg-5 pt-4'>
              <button className="btn btn-primary px-4 rounded-2" type="submit">Submit</button>
              </div>
            </form>
</div>
</div>
</div>
{
      showPass && (
        <ChangePassword
        setShowPass={setShowPass}
        />
      )
    }
   </>
  )
}

export default AddBanner